<div class="loading-container">
  <div class="loading-spinner"></div>
  <p class="loading-message">{{ message }}</p>
</div>
